export enum ComplainFormStatus {
  ALL = 'ALL',
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
  CLOSE = 'CLOSE'
}
